module.exports = __webpack_public_path__ + "img/220.9d6c6db4.jpg";